class Dropdown {
	constructor(element, options = {}) {
		this.dropdownActiveClass = options.dropdownActiveClass || 'is-active';
		this.dropdownTriggerSelector = options.dropdownTriggerSelector || '.js-dropdown-trigger';
		this.dropdownContentSelector = options.dropdownContentSelector || '.js-dropdown-content';

		this.dropdown = element;
		this.dropdownTrigger = this.dropdown.querySelector(this.dropdownTriggerSelector);
		this.dropdownContent = this.dropdown.querySelector(this.dropdownContentSelector);

		this.isActive = this.dropdown.classList.contains(this.dropdownActiveClass);

		this._init();
	}

	_init = () => {
		if (this.isActive) {
			this.open();
		} else {
            this.dropdownContent.style.maxHeight = '0px';
        }

        this._initObserver();

        window.addEventListener('resize', this.updateHeight);
		this.dropdownTrigger.addEventListener('click', this._dropdownTriggerHandler);
		this.dropdown.classList.add('is-init');
	};

    _initObserver = () => {
        const observer = new MutationObserver(mutationList => {
            this.updateHeight();
        });

        observer.observe(this.dropdownContent, {
            childList: true,
            subtree: true,
        });
    }

	_dropdownTriggerHandler = (e) => {
		e.preventDefault();

		if (this.isActive) {
			this.close();
		} else {
			this.open();
		}
	};

	open = () => {
		this.dropdown.classList.add(this.dropdownActiveClass);
		this.dropdownContent.style.maxHeight = `${this.dropdownContent.scrollHeight}px`;
		this.isActive = true;
	};

	close = () => {
		this.dropdown.classList.remove(this.dropdownActiveClass);
		this.dropdownContent.style.maxHeight = `0px`;
		this.isActive = false;
	};

    updateHeight = () => {
        if (this.isActive && this.dropdownContent.offsetHeight !== this.dropdownContent.scrollHeight) {
            this.dropdownContent.style.maxHeight = `${this.dropdownContent.scrollHeight}px`;
        }
    }
}
